<template>
  <div class="create-account">
    <div class="box">
      <svg class="logo" version="1.0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 680 331"
           preserveAspectRatio="xMidYMid meet">
        <g fill="#fff">
          <path
              d="M37.4 328.9 c-0.3 -0.6 -1.5 -0.8 -2.6 -0.6 -2.1 0.6 -5.8 -2.4 -5.8 -4.7 0 -0.8 2.7 -5.1 6 -9.5 3.3 -4.4 6.6 -9.5 7.4 -11.3 0.9 -1.8 2.5 -4.4 3.6 -5.8 1.1 -1.4 5 -11 8.6 -21.5 6.8 -19.4 11.1 -29.1 17 -38.1 1.9 -2.9 5.2 -9.4 7.3 -14.5 9.2 -22.4 17.6 -42 21.6 -49.9 2.3 -4.7 5.7 -12.5 7.5 -17.4 1.8 -4.9 5.9 -13.9 9.1 -20.1 l5.9 -11.2 0 -9.1 c0 -12.1 -1.8 -24.2 -3.6 -24.2 -0.8 0 -1.4 -0.7 -1.4 -1.5 0 -2.5 10.1 -2 15.8 0.9 5.2 2.6 14.3 5.6 24 8.1 8.1 2 16.2 7.1 16.2 10.2 0 1.5 -0.5 2.1 -1.4 1.7 -0.9 -0.3 -2.1 0.5 -3.1 2 -1.5 2.2 -1.6 4.6 -1.2 17.3 0.9 23 2.2 35.2 4.5 40.4 1.1 2.5 3.8 8.4 6 13 2.2 4.7 4.4 9.7 4.7 11.2 0.6 2.2 1 2.5 2.1 1.6 2.7 -2.2 1.5 4.9 -2 11.9 -1.8 3.7 -5.3 11.3 -7.6 17 -3.3 8 -4.7 10.2 -6.2 10.2 -1 0 -1.7 -0.4 -1.4 -0.8 0.3 -0.5 -4.2 -8.5 -10 -17.8 -5.7 -9.3 -11.1 -18.8 -11.9 -21.1 -0.8 -2.4 -2.2 -6.3 -3.1 -8.8 -1 -3 -2.1 -4.5 -3.3 -4.5 -1.8 0 -11 10.3 -20.6 23 -2.7 3.7 -7.1 9.1 -9.6 12.1 -2.5 3 -7.4 9.5 -11 14.4 -3.5 5 -8.2 10.8 -10.4 13 -7.9 8 -10.4 12.1 -14.4 23.9 -3.7 10.8 -9.4 21.1 -13.5 24.5 -1.2 1 -1.6 3.2 -1.6 8.7 0 7.1 -0.1 7.4 -2.9 8.8 -1.6 0.9 -3.1 1.3 -3.4 1 -1.2 -1.3 -3.9 4.6 -3.3 7.3 1.1 5.1 -9.5 14.2 -12 10.2z"/>
          <path
              d="M223.8 311.8 c-1 -0.7 -2.4 -3.8 -3.2 -6.9 -2.2 -8.7 -4 -11.3 -12.9 -18.7 -14.7 -12.3 -21.7 -21.3 -21.7 -27.9 0 -1.5 -0.9 -4.3 -2 -6.1 -1.7 -2.8 -2.3 -3.2 -3.5 -2.2 -2.5 2 -1.9 -3.2 0.7 -6.6 9.2 -12.2 12.3 -15.4 14.6 -15.4 1.9 0 2.2 0.3 1.4 1.3 -1.1 1.3 -0.7 2.6 5.3 18.2 2.9 7.6 10 19.8 17.2 29.6 5.1 7 17.1 19.9 18.5 19.9 0.5 0 3.1 1.6 6 3.5 2.8 1.9 6.2 3.8 7.7 4 6.2 1.2 10.6 3.1 10.6 4.5 0 3.9 -9.7 4.9 -19.3 1.9 -3.5 -1.1 -5 -1.1 -9 0 -7.7 2.2 -8.6 2.3 -10.4 0.9z"/>
          <path
              d="M326 244.6 c-11.5 -2.5 -19.3 -8.4 -24 -17.9 -4.8 -9.8 -5.2 -14.3 -4.8 -56 0.3 -36.9 0.4 -38.4 2.6 -43.8 4.5 -11.3 11.7 -18.2 22.2 -21.3 4.1 -1.2 9.8 -1.6 23.7 -1.6 l18.3 0 0 20 0 20 -11.9 0 c-11.7 0 -16.8 0.9 -18.3 3.3 -0.4 0.7 -0.8 2.9 -0.8 4.9 0 5.9 2.2 6.8 16.7 6.8 l12.3 0 0 15.4 0 15.4 -14 0.4 c-16 0.4 -17.5 1 -17.5 7.8 0 6.9 1.4 7.4 18.5 7.9 l15 0.3 0 19.9 0 19.9 -16.2 -0.1 c-9 0 -18.8 -0.6 -21.8 -1.3z"/>
          <path d="M383 175 l0 -71 16 0 16 0 0 71 0 71 -16 0 -16 0 0 -71z"/>
          <path d="M434 194 l0 -52 16 0 16 0 0 52 0 52 -16 0 -16 0 0 -52z"/>
          <path
              d="M485 228.7 c0 -21.4 1 -25.5 7.9 -32.6 l4.8 -5 -3.4 -3.3 c-1.9 -1.8 -4.7 -5.5 -6.1 -8.3 -2.5 -4.7 -2.6 -6 -3 -21.2 l-0.4 -16.3 16.1 0 16.1 0 0 15.4 c0 14 0.2 15.6 2.1 18 2.5 3.1 5.9 3.4 8.5 0.5 1.7 -1.8 1.9 -4 2.2 -18 l0.3 -15.9 16.1 0 16 0 -0.4 16.8 c-0.5 18.5 -1.9 24.1 -7.9 29.8 l-2.9 2.8 3.4 3.5 c6.3 6.4 6.9 9.3 7.4 31.4 l0.4 19.7 -16.1 0 -16.1 0 0 -17.5 c0 -21.2 -0.9 -24.5 -6.4 -24.5 -6.1 0 -6.6 1.8 -6.6 23.2 l0 18.8 -16 0 -16 0 0 -17.3z"/>
          <path d="M580 194 l0 -52 16 0 16 0 0 52 0 52 -16 0 -16 0 0 -52z"/>
          <path
              d="M632 212.3 c0 -37 0.5 -41.5 5.9 -52.1 7.2 -14.3 21.4 -22 36.5 -19.8 l4.6 0.7 0 20.4 0 20.3 -3.5 -1.1 c-2.5 -0.7 -4.2 -0.7 -6 0.1 -5 2.3 -5.5 5.6 -5.5 36.7 l0 28.5 -16 0 -16 0 0 -33.7z"/>
          <path
              d="M444.4 131.1 c-5.3 -2.4 -8 -6 -9.3 -12.2 -3.3 -15.5 11.2 -28.5 23 -20.6 7.7 5.2 10.4 17.7 5.6 26.1 -4 7.2 -12.2 10 -19.3 6.7z"/>
          <path
              d="M584.6 129.8 c2.3 -3.9 15.8 -21 16.8 -21.4 0.7 -0.3 5.2 -0.4 10 -0.2 l8.7 0.3 -9.6 11.3 -9.5 11.2 -8.6 0 c-6.5 0 -8.3 -0.3 -7.8 -1.2z"/>
          <path
              d="M170 98.1 c-4.5 -2.7 -44.5 -13.1 -50.2 -13.1 -1 0 -1.8 -0.4 -1.8 -1 0 -0.5 0.5 -1 1 -1 1.8 0 1.1 -2 -1.6 -4.5 -1.5 -1.4 -7.7 -5.1 -13.8 -8.4 -6.1 -3.3 -15.2 -8.6 -20.2 -11.9 -8 -5.2 -10.7 -6.4 -22.5 -9.6 -7.4 -2 -17.3 -5.5 -22 -7.7 -6.9 -3.3 -9.3 -4 -11.8 -3.4 -3.8 0.8 -15.2 -3.2 -12.9 -4.6 1.2 -0.8 -0.8 -1.9 -7.3 -4.2 -1.9 -0.6 -6.5 -6.7 -5.1 -6.7 0.4 0 4.2 1.1 8.3 2.5 4.2 1.5 11.5 3 16.9 3.5 11.2 1 42.9 8.6 55 13.1 15.4 5.8 33.5 11.9 35.3 11.9 2.5 0 8.8 3.4 11.1 5.9 l1.9 2.1 3.7 -2.1 c3.8 -2.2 6 -5.4 6 -8.9 0 -2.4 -3.7 -11 -5.8 -13.3 -1.5 -1.7 -3.3 -5.8 -5.3 -12.4 -0.7 -2.4 -0.5 -4.2 1 -8.1 1.1 -2.7 1.8 -5.2 1.5 -5.4 -0.7 -0.7 5.8 -6.9 8.1 -7.8 1.2 -0.4 5 -0.9 8.5 -1.1 6.1 -0.3 6.9 0 12.3 3.5 5.6 3.6 5.8 3.8 4.2 5.6 -1.6 1.8 -1.6 2.3 1 9.4 1.5 4.2 3.4 8.1 4.1 8.7 1.2 1 1.2 1.3 0 2.3 -0.9 0.6 -1.8 4 -2.3 8.1 l-0.8 6.9 -4.3 1.1 c-2.3 0.5 -4.7 1.7 -5.2 2.5 -1.5 2.3 -1.2 7.3 0.6 9.8 2 2.9 7.8 2.9 17.6 0.2 4 -1.1 8.6 -2 10.2 -2 1.7 0 10.2 -2.9 19.1 -6.4 16.4 -6.6 21.7 -8.2 36.5 -11.1 4.7 -0.9 10.5 -2.2 13 -3 2.5 -0.7 7.7 -1.8 11.6 -2.4 3.9 -0.6 8.4 -1.6 10 -2.2 2.8 -1.1 10.4 -2.2 10.4 -1.5 0 0.4 -5.9 6.6 -6.4 6.6 -0.2 0 -2.1 0.7 -4.1 1.6 -2.9 1.2 -3.5 1.8 -2.5 2.4 2.4 1.5 0.6 2.1 -8.6 2.7 -7.7 0.4 -10.2 1.1 -18.6 4.9 -5.3 2.4 -14.2 5.7 -19.9 7.3 -8.2 2.4 -10.9 3.7 -13.3 6.3 -2.1 2.2 -2.3 2.5 -0.5 1 1.4 -1.2 3.1 -2.2 3.7 -2.2 2.1 0 1.3 2.8 -1.4 4.9 -3 2.4 -6.6 2.8 -5.8 0.8 0.2 -0.7 -4.2 0.9 -9.9 3.7 -5.7 2.8 -12.8 6.1 -15.8 7.4 -9.2 3.9 -9.4 4.2 -8 10.9 0.7 3.2 1.7 6.6 2.2 7.6 0.8 1.4 0.4 1.7 -2.3 1.7 -1.8 0 -4 -0.5 -4.8 -0.9z"/>
        </g>
        <g fill="#fff">
          <path
              d="M129.1 329 c-3 -0.7 -5 -2.4 -5.1 -4.1 0 -0.4 2.5 -4.1 5.5 -8.4 3 -4.2 5.5 -7.9 5.5 -8.3 0 -0.3 1.1 -2.2 2.4 -4.1 1.4 -2 5 -10.7 8.1 -19.5 5.9 -16.6 7.6 -20.6 13.1 -29.6 3.1 -5.2 10.8 -22 10 -22 -0.7 0 10.3 -25.2 14.2 -32.4 2.1 -3.9 5.1 -10.7 6.6 -15.1 1.6 -4.4 3.5 -8.7 4.1 -9.5 0.7 -0.8 2.7 -4.6 4.5 -8.3 3.2 -6.7 3.2 -7 2.6 -17.5 -1 -20 -1.6 -23.9 -4 -26 -1.1 -1.1 -7.7 -5.1 -14.6 -8.7 -6.9 -3.7 -14.3 -8 -16.6 -9.6 -2.2 -1.5 -6.9 -3.5 -10.5 -4.4 -9.8 -2.5 -18.9 -5.5 -24.1 -8.1 -2.6 -1.3 -6.2 -2.4 -8 -2.4 -4 0 -12 -2.9 -11.2 -4.1 0.3 -0.5 -1.1 -1.6 -3.2 -2.5 -3.4 -1.4 -7.7 -5.4 -6.9 -6.3 0.2 -0.1 3.4 0.7 7.2 2 3.7 1.2 8.8 2.2 11.3 2.1 5.2 -0.1 32.3 5.7 43.6 9.4 4.2 1.4 9.8 3.6 12.3 4.9 2.5 1.3 8.9 3.6 14.1 5 5.2 1.5 11.2 3.8 13.2 5.1 4.5 2.9 5.5 2.9 8.8 0.4 2.1 -1.6 2.5 -2.7 2.4 -7.1 0 -3.1 -0.5 -5.4 -1.2 -5.7 -0.7 -0.2 -1.2 -0.9 -1.2 -1.5 0 -0.6 -0.6 -1.8 -1.4 -2.6 -0.8 -0.9 -2.4 -4 -3.5 -6.9 l-2.1 -5.2 2.2 -6.5 c1.1 -3.6 2.3 -6.3 2.6 -6 0.3 0.3 1.6 -0.4 2.8 -1.6 1.8 -1.7 3.7 -2.2 8.6 -2.3 5.4 -0.2 6.9 0.2 10.5 2.7 3.7 2.4 4.1 3.1 3.1 4.6 -0.9 1.5 -0.7 3.1 1.2 8 1.2 3.4 2.7 6.4 3.2 6.7 0.5 0.3 0.5 1.1 -0.1 1.8 -0.6 0.7 -1.4 3.7 -1.8 6.7 -0.8 5 -1.1 5.5 -4.3 6.5 -4.5 1.5 -6.1 5.3 -3.9 9.2 1.2 2.2 2.2 2.7 5.4 2.6 7.6 -0.1 22 -3.8 34 -8.6 7.9 -3.2 17.5 -6.1 28 -8.4 8.8 -1.9 19.4 -4.2 23.5 -5.1 4.1 -0.9 8 -1.8 8.5 -1.9 0.6 -0.1 2.4 -0.5 4 -0.9 l3 -0.8 -2.9 3.1 c-1.6 1.8 -4.5 3.7 -6.4 4.3 -2.2 0.7 -3 1.4 -2.2 1.9 2 1.2 -0.2 1.9 -8.1 2.6 -5.4 0.5 -9.7 1.7 -15.9 4.5 -4.7 2.1 -11.6 4.5 -15.4 5.5 -4.8 1.2 -8 2.7 -11 5.3 -2.3 2 -8 5.3 -12.6 7.4 -4.7 2.1 -10.5 4.8 -13 6 l-4.5 2.2 0.4 9.1 c0.3 9 0.3 9.1 -2.9 12.8 l-3.3 3.7 0.7 16.2 c1.1 26.3 1 25.4 7 38.2 2.4 4.9 7.1 17.1 10.5 27 3.5 9.9 7.3 20.5 8.6 23.5 1.3 3 2.6 6.6 3 8 1.8 5.7 13.3 22.6 21.4 31.3 6.1 6.6 19 13.7 24.6 13.7 0.8 0 1.5 0.8 1.5 1.9 0 3.3 -8.2 4.2 -14.4 1.6 -3.4 -1.4 -4.2 -1.4 -9 0.1 -7.9 2.5 -8.8 1.8 -11.5 -8.3 -1.2 -4.4 -3.9 -7.6 -13.5 -15.7 -8.5 -7.2 -13.2 -13.6 -14 -19 -0.6 -3.6 -1.9 -5.9 -5.9 -10.6 -6.8 -7.7 -25.4 -37.5 -27.2 -43.4 -1.8 -6 -3.3 -8.6 -4.9 -8.6 -1.4 0 -12.2 12.5 -17.6 20.5 -1.9 2.8 -5.4 7.5 -7.8 10.5 -2.5 3 -5.9 7.2 -7.6 9.4 -1.7 2.1 -5.3 6.4 -8.1 9.6 -8.3 9.4 -9.4 11.1 -12.1 19.4 -3.2 9.8 -4.3 12 -8.8 17.9 -2.9 3.8 -3.5 5.6 -3.8 10.4 -0.3 5.6 -0.4 5.9 -4 7.6 -3.4 1.7 -3.8 2.3 -3.8 5.6 0 2.9 -0.7 4.4 -3.3 6.9 -3.5 3.4 -3.5 3.4 -8.6 2.2z"/>
          <path
              d="M320 298.7 c-4.9 -1.7 -6 -4.6 -6 -16.2 0 -6.1 0.5 -11 1.3 -12.5 1.8 -3.6 6.7 -4.9 19.5 -4.9 12.1 -0.1 17.2 1.2 19.1 4.7 0.6 1.2 1.1 6.9 1.1 12.7 0 5.8 -0.5 11.5 -1.1 12.7 -1.9 3.5 -7 4.8 -19.1 4.7 -6.2 0 -12.9 -0.5 -14.8 -1.2z m23 -7.7 c1.6 -1.6 2 -3.3 2 -8.5 0 -8.7 -1.7 -10.5 -10.1 -10.5 -9.4 0 -9.9 0.5 -9.9 10.5 0 10 0.4 10.4 9.8 10.5 4.9 0 6.6 -0.4 8.2 -2z"/>
          <path
              d="M372.8 282.5 l-0.3 -17.5 5 0 5 0 10 10 c5.5 5.5 10.3 10 10.7 10 0.5 0 0.8 -4.5 0.8 -10 l0 -10 5.5 0 5.5 0 0 17.5 0 17.5 -4.8 0 c-4.7 0 -4.9 -0.1 -14.7 -10 -5.5 -5.5 -10.3 -10 -10.7 -10 -0.5 0 -0.8 4.5 -0.8 10 l0 10 -5.5 0 -5.4 0 -0.3 -17.5z"/>
          <path
              d="M432.8 282.5 l0.3 -17.5 5.4 0 5.5 0 0 13.5 0 13.5 10.5 0 10.4 0 1.6 3 c0.8 1.6 1.5 3.4 1.5 4 0 0.6 -6 1 -17.7 1 l-17.8 0 0.3 -17.5z"/>
          <path d="M483 282.5 l0 -17.5 5.5 0 5.5 0 0 17.5 0 17.5 -5.5 0 -5.5 0 0 -17.5z"/>
          <path
              d="M512.8 282.5 l-0.3 -17.5 5 0 5 0 10 10 c5.5 5.5 10.3 10 10.7 10 0.5 0 0.8 -4.5 0.8 -10 l0 -10 5.5 0 5.5 0 0 17.5 0 17.5 -4.8 0 c-4.7 0 -4.9 -0.1 -14.7 -10 -5.5 -5.5 -10.3 -10 -10.7 -10 -0.5 0 -0.8 4.5 -0.8 10 l0 10 -5.5 0 -5.4 0 -0.3 -17.5z"/>
          <path
              d="M572 282.5 l0 -17.5 19.5 0 19.5 0 0 3.5 0 3.5 -14 0 -14 0 0 3 0 3 10.5 0 10.5 0 0 4 0 4 -10.5 0 -10.5 0 0 3 0 3 13.3 0 13.3 0 1.7 3.4 c0.8 1.9 1.3 3.7 1 4 -0.4 0.3 -9.6 0.6 -20.5 0.6 l-19.8 0 0 -17.5z"/>
        </g>
      </svg>
      <div class="inner" v-if="user.paid_at">
        <h2>Váš účet</h2>
        <p class="text-center" v-if="user.period != 'none'">
          Vaše členství platí do {{ (new Date(user.expires_at)).toLocaleDateString('cs-CZ') }} a obnovuje se {{ periodText }}. Částka je strhávána automaticky z vaší platební karty použité při registraci.
        </p>
        <p class="text-center" v-else>
          Vaše členství platí do {{ (new Date(user.expires_at)).toLocaleDateString('cs-CZ') }} a již se nebude obnovovat.
        </p>
        <a  v-if="user.period !== 'none'" href="#" class="button" @click="cancelSubscription">Nechat členství doběhnout</a>
        <a  v-if="user.period === 'none'" href="/videos" class="button">Zpět na předtočená videa</a>
      </div>
      <div class="inner" v-if="!user.paid_at">
        <h2>Váš účet</h2>
        <p style="text-align: center;">
          Pro pokračování si prosím vyberte jednu z variant členství níže
        </p>
      </div>
    </div>
    <Subscription v-if="!user.paid_at" :compact="true"/>
  </div>
</template>

<style scoped>

.create-account {
  padding: 120px 20px;
  min-height: 100vh;
  background: url("../assets/bg-create-account.jpg") center center no-repeat;
  background-size: cover;
}
.box {
  width: 100%;
  max-width: 570px;
  margin: 0 auto;
  text-align: center;
}
.logo {
  display: block;
  margin: 0 auto;
  width: 100%;
  max-width: 249px;
  margin-bottom: 35px;
}
.inner {
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 20px 40px 0 rgba(0, 0, 0, 0.39);
  padding: 24px 32px;
}
h2 {
  font-size: 35px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.57;
  letter-spacing: normal;
  text-align: center;
  color: #d11a6f;
  text-transform: none;
  margin-bottom: 20px;
}
input[type=text], input[type=email], input[type=password]  {
  border-radius: 8px;
  background-color: #f5f8fa;
  display: block;
  width: 100%;
  height: 48px;
  padding: 0 15px;
}
.inner p {
  width: 100%;
  margin-bottom: 25px;
  text-align: left;
}
.inner p:last-of-type {
  margin-bottom: 40px;
}
label {
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #8697a8;
  margin-bottom: 7px;
  width: 100%;
  display: block;
}
button, a.button {
  width: 100%;
  display: block;
  border-radius: 8px;
  line-height: 48px;
  background-color: #d22c6f;
  text-align: center;
  color: #fff;
  font-size: 15px;
  font-weight: 500;
  height: 48px;
}

</style>

<script>
import {mapGetters} from "vuex";
import Subscription from "../components/HomePage/Subscription";
export default {
  components: {
    Subscription
  },
  data() {
    return {
      state: null,
    }
  },
  computed: {
    ...mapGetters([
      'user'
    ]),
    periodText() {
      if(this.user.period === 'monthly') {
        return 'každý měsíc';
      }

      if(this.user.period === 'quarterly') {
        return 'každé 3 měsíce';
      }

      if(this.user.period === 'yearly') {
        return 'každý rok';
      }

      return '';
    }
  },
  methods: {
    cancelSubscription() {

      const apiBasePath = 'https://api.elixironline.cz/api';
      //const apiBasePath = 'http://localhost:8000/api';
      window.axios.post(`${apiBasePath}/gopay/cancel`, {
        gopay_id: this.user.gopay_id
      }).then((response) => {
        if(response.data.success) {
          this.user.period = `none`;
        }
      });
    }
  },
  mounted() {
    this.state = this.$route.params.status;
  },
}
</script>
